// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"ElevatorServiceFrontDeskList--next-sr-only--2sbi3Wr","dialog":"ElevatorServiceFrontDeskList--dialog--2Y1c2qi","btn":"ElevatorServiceFrontDeskList--btn--1gGOBag"};